const theme = {
  colors: {
    black: '#555',
    white: '#FDFDFD',
    primary: '#86C7E3',
    primaryLight: '#D2E9F4',
    facebook: '#3b5998',
    secondary: '#8395AB',
    secondaryLight: '#F6F6F6',
    inactive: '#EDEFF2',
    input: '#BFC8D3',
    danger: '#DD9295',
    warning: '#E1B487',
    purple: '#A094E5',
    success: '#B1E498',
  },
  sidebarWidth: '275px',
  fontStack: '"Roboto", "Helvetica Neue", sans-serif',
}

export default theme
